<template>
  <div class="finance">
    <div class="serch">
      <ul>
        <li v-for="item in serchFields" :key="item.field">
          <span>{{ item.field }}</span>
          <el-input
            v-if="item.type === 'input'"
            v-model="serchKey[item.field]"
            style="width:183px"
            size="mini"
            @keyup.enter.native="loadData"
          ></el-input>
          <el-select
            v-else
            v-model="serchKey[item.field]"
            size="mini"
            placeholder
            filterable
            @keyup.enter.native="loadData"
          >
            <el-option v-for="v in serchOption[item.field]" :key="v" :label="v" :value="v"></el-option>
          </el-select>
        </li>
        <li class="radio-group" style="width: 480px;height: 28px;">
          <span>状态：</span>
          <el-radio-group v-model="serchKey.状态">
            <el-radio v-for="item in status" :key="item" :label="item">{{ item }}</el-radio>
          </el-radio-group>
        </li>
        <!-- <li class="radio-group mr10" style="width: 140px;height: 28px;">
          <span>类型：</span>
          <el-radio-group v-model="financeType">
            <el-radio v-for="item in ['新', '旧']" :key="item" :label="item">{{ item }}</el-radio>
          </el-radio-group>
        </li> -->
        <li v-if="financeType === '新'" class="radio-group" style="width: 170px;height: 28px;">
          <span style="width:auto;word-break:keep-all">失败offer：</span>
          <el-radio-group v-model="expired">
            <el-radio v-for="item in ['显示', '隐藏']" :key="item" :label="item">{{ item }}</el-radio>
          </el-radio-group>
        </li>
        <li>
          <div class="radish-btn radish-btn-primary radish-btn-small" style="margin-left: 10px;" @click="toSearch">
            搜索
          </div>
          <div class="radish-btn radish-btn-primary radish-btn-small" style="margin-left: 10px;" @click="clearSerch">
            清空
          </div>

          <!-- <el-button type="primary" size="mini" @click="loadData" style="margin-left: 10px;">搜索</el-button>
          <el-button type="primary" size="mini" @click="clearSerch" style="margin-left: 10px;">清空</el-button> -->
        </li>
      </ul>
    </div>
    <div>
      <!-- <div class="radish-btn radish-btn-primary radish-btn-small" @click="save">保存</div> -->
      <!-- <div class="radish-btn radish-btn-primary radish-btn-small" @click="upload">上传Excel</div> -->
      <!-- <div class="radish-btn radish-btn-primary radish-btn-small" @click="dropFinance">清空财务表</div> -->

      <!-- <el-button type="primary" @click="save" size="mini" plain>保存</el-button>
      <el-button type="primary" @click="upload" size="mini" plain>上传Excel</el-button>
      <el-button type="primary" @click="dropFinance" size="mini" plain>清空财务表</el-button> -->
    </div>
    <el-alert title="所有比例均为百分制" type="warning"></el-alert>
    <el-alert
      title="如果修改了客户公司及人选信息，请及时保存，否则可能会影响到某些字段的校验"
      type="warning"
    ></el-alert>
    <div class="relate-div">
      <waterMark :num="20"></waterMark>
      <el-table
        v-loading="parseing"
        size="mini"
        border
        :data="tableData"
        style="width: 100%"
        :height="listheight"
        highlight-current-row
        :default-sort="{ prop: '序号', order: 'ascending' }"
        :row-class-name="tableRowClassName"
        class="no-bg relate-div"
        row-class-name="no-bg"
        @sort-change="sortChange"
      >
        <el-table-column v-if="isAdmin && activeFinanceType !== '新'" fixed label="操作" width="80">
          <template slot-scope="scope">
            <span class="delete-button" @click="deleteFinance(scope.row)">删除</span>
          </template>
        </el-table-column>
        <el-table-column v-if="activeFinanceType === '新'" label="序号" type="index" fixed width="50">
        </el-table-column>
        <el-table-column
          v-for="col in activeTableHead"
          :key="col.label"
          :prop="col.props"
          :label="col.label"
          :sortable="activeFinanceType === '新' || 'custom'"
          :fixed="col.props === '序号' || col.props === '候选人'"
          :width="col.width"
        >
          <template slot-scope="scope">
            <div v-if="editable[col.props]" class="input_box" @click="toedit(scope, col.props)">
              <!-- 显示类型为百分比，判断是否加百分号 -->
              <span
                v-if="isEditing !== scope.$index + col.props && (col.props === '佣金比例' || col.props === '开票比例')"
                style="margin-left: 10px"
                :class="[col.props === '客户公司' && !scope.row.check ? 'red_font' : '']"
              >
                {{ scope.row[col.props] }} <span v-if="showPercent(scope.row[col.props], col.props)">%</span>
              </span>
              <!-- 显示类型为弹窗，编辑时不会变化 -->
              <el-tooltip
                v-else-if="col.inputMode === 'button' && col.props === '备注'"
                class="item"
                effect="dark"
                :content="scope.row.备注"
                placement="left"
              >
                <div
                  class="radish-btn radish-btn-primary"
                  style="padding: 0px 20px"
                  @click="showDialog(scope.row, col.props)"
                >
                  查看详情
                </div>
                <!-- <el-button @click="showDialog(scope.row,col.props)" size="mini" round>查看详情</el-button> -->
              </el-tooltip>
              <div
                v-else-if="col.inputMode === 'button' && col.props !== '备注'"
                class="radish-btn radish-btn-primary"
                :class="[
                  checkProfitBtnColor(scope.row, col.props) ? 'radish-btn-info' : 'radish-btn-primary',
                  'radish-btn',
                ]"
                style="padding: 0px 20px"
                @click="showDialog(scope.row, col.props)"
              >
                查看详情
              </div>

              <!-- <el-button
              v-else-if="col.inputMode==='button'&&col.props!=='备注'"
              @click="showDialog(scope.row,col.props)"
              size="mini"
              round
            >查看详情</el-button> -->
              <!-- 显示类型为普通字符串 -->
              <span
                v-else-if="isEditing !== scope.$index + col.props && col.props !== '客户公司'"
                style="margin-left: 10px"
                >{{ getDate(scope.row[col.props], col.props)
                }}{{ scope.row[col.props] && getUnit(col.props, scope.row[col.props]) }}</span
              >
              <!-- 显示类型为公司，编辑时不会变化 -->
              <span
                v-else-if="col.props === '客户公司'"
                style="margin-left: 10px"
                :class="[col.props === '客户公司' && !scope.row.check ? 'red_font' : '']"
                >{{ scope.row[col.props] }}</span
              >
              <!-- =================-->
              <!--输入类型为从下拉框中选择-->
              <el-select
                v-else-if="isEditing === scope.$index + col.props && col.inputMode === 'select'"
                v-model="selectValue"
                :allow-create="col.props !== '佣金比例'"
                filterable
                size="mini"
                @change="editEnd(scope.row, col.props, col.inputMode)"
              >
                <el-option
                  v-for="item in selectOption[col.props]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <!-- 输入为日期时 -->
              <el-date-picker
                v-else-if="isEditing === scope.$index + col.props && col.inputMode === 'date'"
                v-model="dateValue"
                type="date"
                size="mini"
                placeholder="选择日期"
                :picker-options="pickerOptions"
                @change="editEnd(scope.row, col.props, col.inputMode)"
              ></el-date-picker>
              <!-- 输入类型为数字 -->
              <el-input-number
                v-else-if="isEditing === scope.$index + col.props && col.inputMode === 'percent'"
                v-model="inputNumber"
                controls-position="right"
                :precision="2"
                :min="0"
                :max="100"
                @change="editEnd(scope.row, col.props, col.inputMode)"
              ></el-input-number>
              <!-- 输入类型为普通字符串 -->
              <el-input
                v-else-if="isEditing === scope.$index + col.props && col.inputMode === 'input'"
                v-model="scope.row[col.props]"
                v-focus
                size="mini"
                @blur="editEnd(scope.row, col.props)"
              ></el-input>
            </div>
            <div v-else>
              <div v-if="col.props === '发票详情'">
                <div
                  class="radish-btn-primary radish-btn"
                  style="padding: 0px 20px"
                  @click="showInvoiceDialog(scope.row)"
                >
                  {{ scope.row.发票 && scope.row.发票.length > 0 ? '查看详情' : '新增开票' }}
                </div>
              </div>
              <div v-else-if="col.props === '付款通知书'">
                <span v-if="hasPayDoc(scope.row)">
                  <span
                    v-if="scope.row.paydocs.length == 1"
                    class="radish-btn radish-btn-primary"
                    style="padding: 0px 20px"
                    @click="previewPay(scope.row.paydocs[0])"
                    >查看</span
                  >
                  <el-popover v-else placement="top" width="350" trigger="click">
                    <div v-for="(doc, k) in scope.row.paydocs" :key="k" class="a-link" @click="previewPay(doc)">
                      {{ doc.originalname }}
                    </div>
                    <span slot="reference" class="radish-btn radish-btn-primary" style="padding: 0px 20px">查看</span>
                  </el-popover>
                </span>
                <span v-else>无</span>
              </div>
              <div
                v-else-if="scope.row.radishProject && col.props === '人选进展阶段' && scope.row.状态 !== '失效'"
                class="radish-btn radish-btn-primary"
                style="padding: 0px 20px"
                @click="showRadishProgress(scope.row.radishProject)"
              >
                {{ getTag(scope.row.radishProject) }}
              </div>
              <div
                v-else-if="scope.row.radishProject && col.props === '人选进展阶段' && scope.row.状态 === '失效'"
                class="radish-btn radish-btn-info"
                style="padding: 0px 20px;background-color:#eee"
              >
                {{ getTag(scope.row.radishProject) }}
              </div>
              <span
                v-else-if="activeFinanceType === '新' && col.props === '候选人'"
                :class="{ 'radish-name': scope.row.rid && scope.row.状态 !== '失效' }"
                @click="showRadish(scope.row)"
              >
                {{ scope.row.候选人
                }}<i
                  v-if="!scope.row.rid"
                  class="el-icon-search"
                  style="color:#1a97e2"
                  @click.stop="defaultSerchRadish(scope, col.props)"
                ></i>
              </span>
              <span v-else style="margin-left: 10px" @click="cancelEdit(scope, col.props)">
                {{ scope.row[col.props] }}
                <i
                  v-if="col.props === '候选人' && !scope.row.rid"
                  class="el-icon-search"
                  style="color:#1a97e2"
                  @click.stop="defaultSerchRadish(scope, col.props)"
                ></i>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="isAdmin && activeFinanceType === '新'" label="操作" width="80">
          <template slot-scope="scope">
            <span class="delete-button" @click="deleteFinance(scope.row)">删除</span>
          </template>
        </el-table-column>
        <!-- <el-table-column v-if="activeFinanceType === '新'" label="发票详情" width="120">
        <template slot-scope="scope">
          <div class="radish-btn radish-btn-primary radish-btn-small" @click="showInvoiceDialog(scope.row)">
            查看详情
          </div>
        </template>
      </el-table-column> -->
      </el-table>
    </div>
    <el-pagination
      class="company-pagination"
      :current-page="page"
      :page-sizes="[50, 100, 200, 300]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></el-pagination>
    <!-- 选择佣金比例 -->
    <el-dialog
      :visible.sync="commissionVisible"
      width="280px"
      :close-on-click-modal="false"
      :modal="true"
      :append-to-body="true"
    >
      <el-input-number
        v-model="commissionValue"
        controls-position="right"
        style="margin:0 auto"
        :precision="2"
        :min="0"
        :max="100"
      ></el-input-number>
      <span slot="footer" class="dialog-footer">
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="commissionVisible = false">取 消</div>
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="saveCommission">确 定</div>
        <!-- <el-button @click="commissionVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="saveCommission" size="mini">确 定</el-button> -->
      </span>
    </el-dialog>
    <!-- 搜索公司弹窗 -->
    <el-dialog
      :visible.sync="dialogCompanyName"
      width="360px"
      :modal="true"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <span style="margin-bottom:5px;">
        没有找到公司名称？点击 <span class="click-span" @click="insertCompany">新建公司</span>
      </span>
      <el-autocomplete
        v-model="serchCompanyName"
        class="inline-input"
        :fetch-suggestions="getCompanyNameOptions"
        placeholder="请输入内容"
        @select="chooseCompanyName"
      ></el-autocomplete>
      <span slot="footer" class="dialog-footer">
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="initChooseCompanyName">取 消</div>
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="modifyCompanyName">确 定</div>

        <!-- <el-button @click="initChooseCompanyName">取 消</el-button>
        <el-button type="primary" @click="modifyCompanyName">确 定</el-button> -->
      </span>
    </el-dialog>
    <!-- 搜索人选弹窗 -->
    <serch-radish-dialog ref="serchRadishDialog" @choose="chooseRadish"> </serch-radish-dialog>
    <serch-radish-dialog ref="bindRadishDialog" choose-btn-text="绑定" @choose="bindRadish"> </serch-radish-dialog>
    <!-- 查看业绩分成详情 -->
    <!-- <el-dialog :visible.sync="dialogProfitShow" width="400px" :modal="true" :append-to-body="true"> -->
    <div v-if="dialogProfitShow" class="dialog-modal">
      <div class="dialog-serchRadish">
        <el-alert
          v-if="profitAlert"
          :title="profitAlert"
          type="warning">
        </el-alert>
        <ul>
          <li class="profit-tablehead">
            <span class="profit-tablehead-type">类别</span>
            <div><span>姓名</span> <span>业绩分成</span> <span>业绩</span></div>
          </li>
          <li v-for="type in dialogTableKeys" :key="type" class="border-bottom">
            <span class="dialog-label">{{ type }}：</span>
            <ul class="dialog-inputbox">
              <li v-for="(val, index) in dialogProfitValue[type]" :key="val.account + index" style="display:flex">
                <el-select v-model="val.account" filterable style="width:33%" size="mini">
                  <el-option v-for="item in users" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-input-number
                  v-model="val.profitPercent"
                  style="width:33%"
                  size="mini"
                  :controls="false"
                  :min="0"
                  :max="100"
                  :disabled="havePerformance&&!havePercent"
                  @change="checkProfitPercent(type, index)"
                ></el-input-number>
                <el-input-number
                  v-model="val.performance"
                  style="width:33%"
                  size="mini"
                  :controls="false"
                  :disabled="havePercent"
                  @change="checkProfitPercent(type, index)"
                  :min="0"
                ></el-input-number>
                <i
                  class="el-icon-close"
                  size="mini"
                  style="color:#fb1616;"
                  circle
                  @click="removerow('profit', type, index)"
                ></i>
              </li>
            </ul>
            <i class="el-icon-circle-plus-outline dialog-addbtn" size="mini" circle @click="addrow('profit', type)"></i>
          </li>
          <li class="profit-tablehead">
            <span class="profit-tablehead-type">汇总</span>
            <div>
              <span></span> <span>{{ getSummary('业绩分成') }}</span> <span>{{ getSummary('业绩') }}</span>
            </div>
          </li>
        </ul>
        <span slot="footer" class="dialog-footer" style="float: right;">
          <!-- <el-button size="mini" @click="dialogProfitShow = false">取 消</el-button> -->
          <div class="radish-btn radish-btn-primary radish-btn-small" @click="saveDialog('profit')">确 定</div>
          <!-- <el-button size="mini" type="primary" @click="saveDialog('profit')">确 定</el-button> -->
        </span>
      </div>
    </div>
    <!-- </el-dialog> -->
    <!-- 查看提成比例详情 -->
    <!-- <el-dialog :visible.sync="dialogCommissionShow" width="480px" :modal="true" :append-to-body="true"> -->
    <div v-if="dialogCommissionShow" class="dialog-modal">
      <div class="dialog-serchRadish">
        <ul>
          <li class="commission-tablehead">
            <span class="commission-tablehead-type">类别</span>
            <div><span>姓名</span> <span>业绩</span> <span>提成比例</span> <span>类型</span> <span>提成</span></div>
          </li>
          <li v-for="type in dialogTableKeys" :key="type" class="border-bottom">
            <span class="dialog-label" style="width:13%">{{ type }}：</span>
            <ul class="dialog-inputbox" style="width:80%">
              <li v-for="(val, index) in tableData[dialogIndex][type]" :key="val.account + index" style="display:flex">
                <el-select v-model="val.account" filterable style="width:25%" size="mini">
                  <el-option v-for="item in users" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-input-number
                  v-model="val.performance"
                  style="width:25%"
                  size="mini"
                  :controls="false"
                  :disabled="true"
                  :min="0"
                ></el-input-number>
                <el-input-number
                  v-model="val.commissionPercent"
                  style="width:25%"
                  size="mini"
                  :controls="false"
                  :disabled="val.type === '固定'"
                  :precision="2"
                  :min="0"
                  :max="100"
                  @change="inputComputeCommission(type, index)"
                ></el-input-number>
                <el-select
                  v-model="val.type"
                  filterable
                  class="hidden-select"
                  style="width:60px"
                  size="mini"
                  @change="changeCommissionType(val)"
                >
                  <el-option label="比例" value="比例"></el-option>
                  <el-option label="固定" value="固定"></el-option>
                </el-select>
                <el-input-number
                  v-model="val.commission"
                  style="width:25%"
                  size="mini"
                  :controls="false"
                  :disabled="val.type === '比例'"
                  :min="0"
                ></el-input-number>
                <i
                  class="el-icon-close"
                  size="mini"
                  style="color:#fb1616;"
                  circle
                  @click="removerow('commission', type, index)"
                ></i>
              </li>
            </ul>
            <i
              class="el-icon-circle-plus-outline dialog-addbtn"
              style="width:7%"
              size="mini"
              circle
              @click="addrow('commission', type)"
            ></i>
          </li>
          <li class="commission-tablehead">
            <span class="commission-tablehead-type">汇总</span>
            <div>
              <span></span> <span>{{ getSummary('业绩') }}</span> <span></span> <span></span>
              <span>{{ getSummary('提成') }}</span>
            </div>
          </li>
        </ul>
        <span slot="footer" class="dialog-footer" style="float: right;">
          <!-- <el-button size="mini" @click="dialogCommissionShow = false">取 消</el-button> -->
          <div class="radish-btn radish-btn-primary radish-btn-small" @click="saveDialog('commission')">确 定</div>
          <!-- <el-button size="mini" type="primary" @click="saveDialog('commission')">确 定</el-button> -->
        </span>
      </div>
    </div>
    <!-- </el-dialog> -->
    <!-- 备注 -->
    <el-dialog
      :visible.sync="dialogComment"
      width="480px"
      :modal="true"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-input v-model="commentValue" type="textarea" :rows="2" placeholder="请输入内容"></el-input>
      <span slot="footer" class="dialog-footer">
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="dialogComment = false">取 消</div>
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="saveDialog('comment')">确 定</div>

        <!-- <el-button size="mini" @click="dialogComment = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="saveDialog('comment')">确 定</el-button> -->
      </span>
    </el-dialog>
    <!-- 删除一条财务信息 -->
    <el-dialog
      :visible.sync="deleteFinanceDialog"
      width="480px"
      :modal="true"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <span>确定删除这条信息吗？</span>
      <span slot="footer" class="dialog-footer">
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="initDeleteFinance">取 消</div>
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="confirmDelete">确 定</div>

        <!-- <el-button size="mini" @click="initDeleteFinance">取 消</el-button>
        <el-button size="mini" type="primary" @click="confirmDelete">确 定</el-button> -->
      </span>
    </el-dialog>
    <UploadDialog ref="UploadDialog" type="解析" :on-success="uploadsuccess" :on-error="uploaderror" />
    <Invoice ref="Invoice" type="解析" />
    <radishProgress ref="radishProgress"></radishProgress>
  </div>
</template>
<script>
import serchRadishDialog from './component/serchRadishDialog.vue'
import Invoice from './component/Invoice'
import radishProgress from '../../radish/src/progress/radish-progress.vue'

export default {
  components: { serchRadishDialog, Invoice, radishProgress },
  directives: {
    focus: {
      inserted: function(el) {
        el.querySelector('input').focus()
      },
    },
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 50,
      parseing: false,
      profitAlert:'',
      sort: {},
      listheight: '100px',
      dateValue: '',
      commissionVisible: false,
      commissionValue: '',
      editIndex: '',
      isEditing: '',
      users: [],
      dialogTableKeys: ['客户开发', '项目对接', '项目经理', '项目成员'],
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            },
          },
        ],
      },
      tableData: [],
      tableHead: [
        { label: '序号', props: '序号', width: '70' },
        { label: '候选人', props: '候选人', width: '90' },
        { label: '手机号', props: '手机号', width: '130' },
        { label: '年份', props: '年份', width: '80', inputMode: 'input' },
        {
          label: '职能模块',
          props: '职能模块',
          width: '130',
          inputMode: 'select',
        },
        {
          label: '目前职位',
          props: '目前职位',
          width: '150',
          inputMode: 'input',
        },
        { label: '职级', props: '职级', width: '70', inputMode: 'input' },
        {
          label: '客户公司',
          props: '客户公司',
          width: '130',
          inputMode: '',
        },
        {
          label: '本次发票金额',
          props: '发票金额',
          width: '120',
          inputMode: 'input',
        },
        {
          label: '固定年薪',
          props: '固定年薪',
          width: '100',
          inputMode: 'input',
        },
        {
          label: '合同比例',
          props: '佣金比例',
          width: '100',
          inputMode: 'select',
        },
        { label: '佣金额', props: '佣金额', width: '85', inputMode: 'input' },
        {
          label: '开票批次',
          props: '开票批次',
          width: '100',
          inputMode: 'select',
        },
        {
          label: '开票比例',
          props: '开票比例',
          width: '100',
          inputMode: 'percent',
        },
        {
          label: '付款通知书编号',
          props: '付款通知书编号',
          width: '130',
        },
        {
          label: '旧付款通知书编号',
          props: '旧付款通知书编号',
          width: '145',
        },
        {
          label: '此单保证期',
          props: '保证期',
          width: '110',
          inputMode: 'input',
        },

        {
          label: 'offer签订日期',
          props: 'offer签订日期',
          width: '120',
          inputMode: 'date',
        },

        {
          label: '预计到岗日期',
          props: '预计到岗日期',
          width: '120',
          inputMode: 'date',
        },
        {
          label: '到岗日期',
          props: '到岗日期',
          width: '100',
          inputMode: 'date',
        },
        {
          label: '开票主体',
          props: '开具发票',
          width: '120',
          inputMode: 'select',
        },
        {
          label: '发票寄出日期',
          props: '发票寄出日期',
          width: '120',
          inputMode: 'date',
        },
        {
          label: '回款日期',
          props: '回款日期',
          width: '100',
          inputMode: 'date',
        },
        { label: 'OFFER', props: 'offer', width: '110', inputMode: 'select' },
        {
          label: '付款通知书',
          props: '付款通知书',
          width: '110',
          inputMode: 'button',
        },
        {
          label: '业绩分成',
          props: '业绩分成',
          width: '120',
          inputMode: 'button',
        },
        {
          label: '提成比例',
          props: '提成比例',
          width: '120',
          inputMode: 'button',
        },
        {
          label: '发票详情',
          props: '发票详情',
          width: '120',
          inputMode: 'button',
        },
        {
          label: '备注',
          props: '备注',
          width: '120',
          inputMode: 'button',
        },
      ],
      editable: {
        年份: true,
        序号: false,
        职能模块: true,
        目前职位: true,
        职级: true,
        客户公司: true,
        候选人: false,
        发票金额: true,
        固定年薪: true,
        佣金比例: true,
        佣金额: true,
        开票批次: true,
        开票比例: true,
        到岗日期: true,
        预计到岗日期: true,
        付款通知书编号: false,
        旧付款通知书编号: false,
        开具发票: true,
        发票寄出日期: true,
        回款日期: true,
        保证期: true,
        提成比例: true,
        offer: true,
        业绩分成: true,
        offer签订日期: true,
        备注: true,
      },
      inputNumber: '',
      selectValue: '',
      selectOption: {
        职能模块: [],
        开票批次: [
          { label: '0（一次付款）', value: '0' },
          { label: '1（第一期款）', value: '1' },
          { label: '2（第二期款）', value: '2' },
        ],
        保证期: [{ label: '3个月', value: '3个月' }, { label: '6个月', value: '6个月' }],
        佣金比例: [
          { label: '选择比例', value: '选择比例' },
          { label: '固定收费', value: '固定收费' },
          { label: '最低收费', value: '最低收费' },
        ],
        offer: [],
        开具发票: [
          { label: '北京阿尔法', value: '北京阿尔法' },
          { label: '浙江阿尔法', value: '浙江阿尔法' },
          { label: '新疆阿尔法', value: '新疆阿尔法' },
        ],
      },
      // changeIndex: [],
      percentType: ['佣金比例', '开票比例', '提成比例'],
      isAdmin: false,
      dialogProfitShow: false,
      dialogCommissionShow: false,
      dialogProfitValue: {},
      dialogCommissionValue: {},
      dialogIndex: '',
      dialogCompanyName: false,
      serchCompanyName: '',
      chooseNameBySelect: false,
      timeOut: '',
      companyNameQueryString: '',
      serchFields: [
        { field: '客户公司', type: 'input' },
        { field: '候选人', type: 'input' },
        // { field: '手机号', type: 'input' },
        { field: '年份', type: 'select' },
        { field: '职能模块', type: 'select' },
        { field: 'offer', type: 'select' },
        { field: '顾问', type: 'select' },
      ],
      serchOption: {
        年份: ['2013', '2014', '2015', '2016', '2017', '2018', '2019', '2020'],
        职能模块: [],
        offer: [],
        顾问: [],
      },
      status: ['所有', 'offer未到岗', '到岗未开票', '已开票未回款', '已回款'],
      serchKey: {
        客户公司: '',
        候选人: '',
        手机号: '',
        年份: '',
        职能模块: '',
        offer: '',
        顾问: '',
        状态: '',
      },
      dialogComment: false,
      commentValue: '',
      deleteFinanceId: '',
      deleteFinanceDialog: false,
      financeType: '新',
      expired: '显示',
      activeFinanceType: '新',
      activeTableHead: [],
    }
  },
  computed: {
    havePercent() {
      let flag = false
      this.dialogTableKeys.forEach(field => {
        this.dialogProfitValue[field].forEach(v=>{
          if(v.profitPercent) flag = true
        })
      })
      return flag
    },
    havePerformance() {
      let flag = false
      this.dialogTableKeys.forEach(field => {
        this.dialogProfitValue[field].forEach(v=>{
          if(v.performance) flag = true
        })
      })
      return flag
    },
  },
  async mounted() {
    this.isAdmin = app.user.角色 && app.user.角色.includes('管理员')
    this.loadData()
    this.setOption()
    this.init()
  },
  created() {
    this.listheight = window.innerHeight - 278
  },
  methods: {
    init() {
      const arr = []
      const num = 2013
      const year = new Date().getFullYear()
      for (let i = num; i <= year; i++) {
        arr.push(`${i}`)
      }
      arr.reverse()
      this.serchOption.年份 = arr
    },
    checkProfitBtnColor(row, props) {
      if (!['业绩分成', '提成比例'].includes(props)) return false
      const { dialogTableKeys } = this
      const fieldMap = {
        业绩分成: 'profitPercent',
        提成比例: 'commissionPercent',
      }
      let num = 0
      if(props==='业绩分成'){
        let performanceNum = 0
        dialogTableKeys.forEach(val => {
          const arr = row[val] || []
          arr.forEach(v => {
            const value = v[fieldMap[props]]
            const performanceValue = v.performance
            if (value) num += 1
            if (performanceValue) performanceNum += 1
          })
        })
        return (num === 0&&performanceNum === 0)
      }else{
        dialogTableKeys.forEach(val => {
          const arr = row[val] || []
          arr.forEach(v => {
            const value = v[fieldMap[props]]
            if (value) num += 1
          })
        })
        return num === 0
      }
    },
    invoiceShowBadge(row) {
      const invoice = (row.发票 || []).filter(v => !v.isDeleted)
      const kaipiao = invoice.filter(v => v.开票时间)
      const flag = (invoice.length > 0 && kaipiao.length === 0) || invoice.length === 0
      return flag && row.invoiceBadge
    },
    showRadishProgress(row = {}) {
      if (!row.rid || !row.pid) return
      this.$refs.radishProgress.open({ pid: row.pid, rid: row.rid, logOnly: true })
    },
    getTag(row = {}) {
      if (!row.状态 || !row.状态.tag) {
        return 'Call'
      } else if (row.状态.tag === '过保') {
        if (row.状态.detail === '淘汰' || row.状态.detail === '放弃') {
          return '未过保'
        }
        return '过保'
      } else if (row.状态.detail === '淘汰' || row.状态.detail === '放弃') {
        return `已${row.状态.detail}`
      } else if (row.状态.tag === '已推荐') {
        return '推荐'
      } else if (row.状态.tag === '面试') {
        if (row.状态.detail === '终面') {
          return '终面'
        } else {
          return '面试'
        }
      } else if (row.状态.tag === 'offer谈判') {
        return 'offer谈判'
      } else if (row.状态.tag === 'offer') {
        return '离职辅导'
      } else if (row.状态.tag === '到岗') {
        return '到岗'
      }
      return ''
    },
    showRadish(row) {
      if (!row.rid || row.状态 === '失效') return
      window.open(`${window.frontend}/#/radish-detail-blank/${row.rid}`, '_blank')
      // app.root.$refs.radishDetailTab.addTab({ id: row.rid })
    },
    getSummary(field) {
      const fieldMap = {
        业绩分成: 'profitPercent',
        业绩: 'performance',
        提成: 'commission',
      }
      let num = 0
      const activeRow = this.tableData[this.dialogIndex]
      this.dialogTableKeys.forEach(val => {
        const arr = activeRow[val] || []
        arr.forEach(v => {
          const value = v[fieldMap[field]]
          const value2num = typeof value === 'number' ? value : isNaN(parseFloat(value)) ? 0 : parseFloat(value)
          if (value2num) num += value2num
        })
      })
      return num
    },
    getUnit(prop, val) {
      const arr = ['固定年薪', '佣金额']
      // const arr2 = ['合同比例']
      if (arr.includes(prop) && !`${val}`.includes('万') && parseFloat(val) < 10000) return '万'
      else if (prop === '保证期' && !val.includes('月')) return '个月'
      // else if (arr2.includes(prop)) return '%'
      else return ''
    },
    getActiveTableHead() {
      const filterFields = [
        '本次发票金额',
        '开票批次',
        '开票比例',
        '付款通知书编号',
        '旧付款通知书编号',
        '开票主体',
        '发票寄出日期',
        '回款日期',
        '手机号',
        '序号',
      ]
      if (this.financeType === '新') {
        const arr = this.tableHead.filter(v => !filterFields.includes(v.label))
        arr.push({ label: '人选进展阶段', props: '人选进展阶段', width: '160' })
        const sortFields = ['年份', '候选人', '职能模块', '客户公司', '目前职位', '职级', '人选进展阶段', '固定年薪']
        const arr1 = []
        sortFields.forEach(v => {
          const obj = arr.find(val => val.label === v)
          if (obj) arr1.push(obj)
        })
        const arr2 = arr.filter(v => !sortFields.includes(v.label))
        this.activeTableHead = arr1.concat(arr2)
      } else {
        this.activeTableHead = this.tableHead.filter(v => v.label !== '发票详情')
      }
    },
    toSearch() {
      this.page = 1
      this.loadData()
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.状态 === '失效') return 'finance-info-row'
    },
    showInvoiceDialog(row) {
      if (row.状态 === '失效') return
      this.$refs.Invoice.open(row)
    },
    deleteFinance(row) {
      if (row.状态 === '失效') return
      this.deleteFinanceId = row._id
      this.deleteFinanceDialog = true
    },
    async confirmDelete() {
      const result = await app.service('company').deleteFinance(this.deleteFinanceId)
      if (result.status === 'success') {
        const index = this.findRowById(this.deleteFinanceId)
        this.tableData.splice(index, 1)
      } else {
        this.$message(result.msg)
      }
      this.initDeleteFinance()
    },
    initDeleteFinance() {
      this.deleteFinanceId = ''
      this.deleteFinanceDialog = false
    },
    changeCommissionType(val) {
      val.commissionPercent = 0
    },
    clearSerch() {
      for (const key in this.serchKey) {
        this.serchKey[key] = ''
      }
      this.sort = { 年份: 1, 序号: 1, 开票批次: 1 }
      this.page = 1
      this.loadData()
    },
    chooseRadish(radish) {
      const row = this.tableData[this.editIndex]
      const indexArr = this.getSameProjectIndex(this.editIndex)
      indexArr.forEach((val, index) => {
        this.tableData[val].候选人 = radish.姓名
        this.tableData[val].手机号 = radish.手机
      })
    },
    async bindRadish(radish) {
      try {
        const row = this.tableData[this.editIndex]
        // console.log('🚀 ~ file: finance.vue ~ line 1003 ~ bindRadish ~ row', row)
        await app.service('radish').bindFinance({ _id: row._id, rid: radish._id })
        await this.loadData()
        this.$message.success(`绑定成功`)
      } catch (e) {
        this.$message.error(`绑定出错了`)
      }
    },
    async defaultSerchRadish({ row, column, $index }, props) {
      if (row.状态 === '失效') return
      this.editIndex = this.findRowById(row._id)
      this.$refs.bindRadishDialog.open({ 姓名: row.候选人, 手机: row.手机号 })
    },
    insertCompany() {
      this.initChooseCompanyName()
      window.open(`${window.origin}/#/NewAddCompany`, '_blank')
    },
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    getCompanyNameOptions(queryString, cb) {
      if (queryString !== '') {
        if (this.timeOut !== '') {
          clearTimeout(this.timeOut)
        }
        this.timeOut = setTimeout(() => {
          this.timeOut = ''
          this.serchCompanyNameOptions(queryString, cb)
        }, 500)
      }
    },
    async serchCompanyNameOptions(queryString, cb) {
      if (this.companyNameQueryString !== queryString) {
        this.chooseNameBySelect = false
      }
      this.companyNameQueryString = queryString
      const serchResult = await window.app.service('company').serchCompany(queryString)
      if (serchResult.status !== 200) {
        this.$message(serchResult.msg)
      } else {
        const companyArr = serchResult.data
        const resultArr = companyArr.map(company => ({ _id: company._id, value: company.公司名称 }))
        cb(resultArr)
      }
    },
    chooseCompanyName(name) {
      this.chooseNameBySelect = true
    },
    // async dropFinance() {
    //   const result = await window.app.service('company').dropFinance()
    //   if (result === 'ok') {
    //     this.$message('清空成功')
    //     this.loadData()
    //   }
    // },
    // 检查该字段是否需要显示百分号
    showPercent(val, key) {
      const hasValue = val
      const isPercent = this.percentType.includes(key)
      const onlyNumber = /^[0-9.]*$/.test(val)
      if (hasValue && isPercent && onlyNumber) {
        return true
      } else {
        return false
      }
    },
    getDate(val, key) {
      const dateType = ['offer签订日期', '预计到岗日期', '到岗日期', '发票寄出日期', '回款日期']
      if (dateType.includes(key) && val) {
        const year = new Date(val).getFullYear()
        const month = new Date(val).getMonth() + 1
        const data = new Date(val).getDate()
        return `${year}/${month}/${data}`
      } else {
        return val
      }
    },
    toedit({ row, column, $index }, props) {
      if (row.状态 === '失效') return
      if (props === '预计到岗日期' && row.到岗日期) return
      this.editIndex = this.findRowById(row._id)
      this.isEditing = $index + props
      if (props === '客户公司') {
        this.dialogCompanyName = true
        this.serchCompanyName = row[props]
      }
      this.selectValue = row[props]
      this.inputNumber = row[props]
      this.dateValue = row[props]
    },
    initChooseCompanyName() {
      this.editIndex = ''
      this.isEditing = ''
      this.serchCompanyName = ''
      this.dialogCompanyName = false
      this.chooseNameBySelect = false
    },
    modifyCompanyName() {
      if (this.tableData[this.editIndex].客户公司 !== this.serchCompanyName) {
        this.tableData[this.editIndex].客户公司 = this.serchCompanyName
        this.tableData[this.editIndex].check = this.chooseNameBySelect
        this.save()
        this.initChooseCompanyName()
      }
    },
    showCommissionDialog(index) {
      this.commissionVisible = true
      const value = this.tableData[index].佣金比例
      const onlyNumber = /^[0-9.]*$/
      this.commissionValue = onlyNumber.test(value) ? value : 0
      this.editIndex = index
    },
    saveCommission() {
      this.tableData[this.editIndex].佣金比例 = this.commissionValue
      this.commissionVisible = false
      this.syncChange(this.editIndex, '佣金比例')
    },
    // 计算所有需要计算的字段的函数
    computeMoney(index) {
      const row = this.tableData[index]
      const salary = this.stringToNumber(row.固定年薪)
      const commissionRate = this.stringToNumber(row.佣金比例)
      const invoiceRate = this.stringToNumber(row.开票比例)
      let commission = this.stringToNumber(row.佣金额)
      if (salary !== '' && commissionRate !== '') {
        // commission = salary * commissionRate * 0.01
        commission = this.floatMul([salary, commissionRate, 0.01])
        this.tableData[index].佣金额 = commission
      }
      if (commission !== '' && invoiceRate !== '') {
        // this.tableData[index].发票金额 = commission * invoiceRate * 0.01
        this.tableData[index].发票金额 = this.floatMul([commission, invoiceRate, 0.01])
      }
      this.computeCommission(index)
    },
    async computeCommission(index) {
      const row = this.tableData[index]
      const profit = row.业绩分成
      const commmission = row.提成比例
      this.dialogTableKeys.forEach(key => {
        if (Array.isArray(row[key])) {
          row[key].forEach(val => {
            if (val.profitPercent && row.佣金额) {
              // val.performance = this.stringToNumber(row.佣金额) * 10000 * val.profitPercent * 0.01
              val.performance = this.floatMul([this.stringToNumber(row.佣金额), 10000, val.profitPercent, 0.01])
              // val.commission = val.commissionPercent == 0 ? 0 : val.performance * 0.94 * val.commissionPercent * 0.01
            }
            if (val.commissionPercent && val.performance) {
              val.commission = this.floatMul([val.performance, 0.94, val.commissionPercent, 0.01])
            }
          })
        }
      })
      await this.saveRow(row)
    },
    async saveRow(row) {
      const result = await window.app.service('company').saveFinance([row])
      if (result.status !== 200) {
        this.$message('保存失败，请稍后重试')
      }
    },
    stringToNumber(str) {
      const num = parseFloat(str)
      return isNaN(num) ? '' : num
    },
    findRowById(id) {
      let index
      this.tableData.forEach((val, ind) => {
        if (val._id === id) {
          index = ind
        }
      })
      return index
    },
    async editEnd(row, type, inputMode) {
      const index = this.findRowById(row._id)
      const item = this.tableData[index]
      const computedKeys = ['固定年薪', '佣金额', '开票比例']
      // if (type === '开票比例') {
      //   this.tableData[index][type] = this.inputNumber
      //   this.checkInvoicePercent(index)
      // }
      if (computedKeys.includes(type)) {
        this.computeMoney(index)
      } else if (type === '佣金比例') {
        if (this.selectValue === '选择比例') {
          this.showCommissionDialog(index)
        } else {
          this.$set(this.tableData[index], type, this.selectValue)
        }
      } else if (type === '开票批次') {
        this.$set(this.tableData[index], type, this.selectValue)
        if (this.selectValue === '0') {
          this.$set(this.tableData[index], '开票比例', 100)
        } else if (this.selectValue === '1') {
          this.checkInsertRow(index)
        } else {
          this.checkInvoicePercent(index)
        }
        this.computeMoney(index)
      } else if (type === '保证期') {
        const val = this.tableData[index][type]
        if (val && !/^[0-9.]*$/.test(val)) this.$message.error('请输入纯数字')
      } else if (inputMode === 'percent') {
        this.$set(this.tableData[index], type, this.inputNumber)
      } else if (inputMode === 'select') {
        this.$set(this.tableData[index], type, this.selectValue)
      } else if (inputMode === 'date') {
        this.$set(this.tableData[index], type, new Date(this.dateValue).getTime())
        if (type === 'offer签订日期' && item.rid && item.pid) {
          await app.service('radish').financeCheckOffer({ rid: item.rid, pid: item.pid, time: this.dateValue })
        }
      } else if (type === '年份') {
        await this.syncPaymentNumber(index)
      }
      this.syncChange(index, type)
      this.isEditing = ''
    },
    async syncPaymentNumber(index) {
      const row = this.tableData[index]
      const result = await app.service('company').getNewSerialNumber(row)
      if (result.status === 'success') {
        row.序号 = result.data.序号
        row.付款通知书编号 = result.data.付款通知书编号
      } else {
        this.$message(result.msg)
      }
    },
    syncChange(index, key) {
      const notSyncKey = ['开票批次', '开票比例', '发票金额', '发票寄出日期', '回款日期']
      if (!notSyncKey.includes(key)) {
        const toChangeIndex = this.getSameProjectIndex(index)
        toChangeIndex.forEach(ind => {
          if (ind !== index) {
            if (typeof this.tableData[index][key] === 'object') {
              this.$set(this.tableData[ind], key, JSON.parse(JSON.stringify(this.tableData[index][key])))
              // this.tableData[ind][key] = JSON.parse(JSON.stringify(this.tableData[index][key]))
            } else {
              this.tableData[ind][key] = this.tableData[index][key]
              if (key === '年份') {
                this.tableData[ind].付款通知书编号 = this.tableData[index].付款通知书编号
              }
            }
          }
          this.computeMoney(ind)
        })
      }
    },
    async checkInsertRow(index) {
      const row = this.tableData[index]
      const response = await window.app.service('company').checkFinanceNumber(row)
      if (response.status === '200') {
        const newRow = JSON.parse(JSON.stringify(row))
        newRow.开票批次 = '2'
        newRow.开票比例 = 100 - row.开票比例
        this.tableData.splice(index + 1, 0, newRow)
        this.computeMoney(index + 1)
      } else {
        this.$message(response.msg)
      }
    },
    getSameProjectIndex(index) {
      const result = [index]
      // const changeitem = this.tableData[index]
      // const checkfield = ['客户公司', '候选人', '手机号', '年份']
      // this.tableData.map((item, mapindex) => {
      //   const notsame = mapindex !== index
      //   let valsame = true
      //   checkfield.map(key => {
      //     if (changeitem[key] !== item[key]) {
      //       valsame = false
      //     }
      //   })
      //   if (notsame && valsame) {
      //     result.push(mapindex)
      //   }
      // })
      return result
    },
    checkInvoicePercent(index) {
      const changeitem = this.tableData[index]
      const indexArr = this.getSameProjectIndex(index)
      indexArr.forEach(ind => {
        if (ind !== index) {
          const item = this.tableData[ind]
          item.开票比例 = 100 - changeitem.开票比例
        }
        this.computeMoney(ind)
      })
    },
    checkProfitPercent(type, index) {
      //  计算业绩分成之和是否超过100
      let num = 0
      let performance = 0
      const row = this.tableData[this.dialogIndex]
      this.dialogTableKeys.forEach(key => {
        row[key].map(item => {
          if (item.profitPercent) {
            num += item.profitPercent
          }
          if (item.performance) {
            performance += item.performance
          }
        })
      })
      if (num > 100) {
        this.$message.warning('所有成员的所占百分比相加超过了100%，请重新输入')
        this.profitAlert = '所有成员的所占百分比相加超过了100%'
        row[type][index].profitPercent = 0
        row[type][index].performance = 0
      } else if (performance > row.佣金额 * 10000){
        this.$message.warning('所有成员的业绩相加超过了佣金额，请重新输入')
        this.profitAlert = '所有成员的业绩相加超过了佣金额'
        row[type][index].performance = 0
      } else {
        this.profitAlert = ''
        // 计算业绩-->佣金额*业绩分成
        const invoiceValue = this.stringToNumber(row.佣金额)
        if (invoiceValue) {
          // row[type][index].performance = invoiceValue * 10000 * row[type][index].profitPercent * 0.01
          // row[type][index].commission = row[type][index].performance * 0.94 * row[type][index].commissionPercent * 0.01
          if(row[type][index].profitPercent){
            row[type][index].performance = this.floatMul([invoiceValue, 10000, row[type][index].profitPercent, 0.01])
          }
          row[type][index].commission = this.floatMul([
            row[type][index].performance,
            0.94,
            row[type][index].commissionPercent,
            0.01,
          ])
        } else {
          this.$message('未设置过发票金额或含有非数字字符，无法自动计算，请确认发票金额')
        }
      }
    },
    inputComputeCommission(type, index) {
      const row = this.tableData[this.dialogIndex][type][index]
      if (row.performance && row.commissionPercent) {
        // row.commission = row.performance * 0.94 * row.commissionPercent * 0.01
        row.commission = this.floatMul([row.performance, 0.94, row.commissionPercent, 0.01])
      }
    },
    cancelEdit() {
      this.isEditing = ''
    },
    showDialog(row, type) {
      if (row.状态 === '失效') return
      const index = this.findRowById(row._id)
      this.dialogIndex = index
      if (type === '备注') {
        this.dialogComment = true
        this.commentValue = this.tableData[index].备注
        return
      }

      this.dialogTableKeys.forEach(field => {
        const val = this.tableData[index][field]
        if (!val || !Array.isArray(val)) {
          const obj = {
            account: '',
            profitPercent: 0,
            performance: 0,
            commissionPercent: 27,
            commission: 0,
            type: '比例',
          }
          this.$set(this.tableData[index], field, [obj])
        }
      })
      if (type === '业绩分成') {
        this.dialogProfitShow = true
        this.dialogProfitValue = {}
        this.dialogTableKeys.forEach(field => {
          this.$set(this.dialogProfitValue, field, this.tableData[index][field] || [])
        })
      } else {
        this.dialogCommissionShow = true
        this.dialogCommissionValue = {}
        this.dialogTableKeys.forEach(field => {
          this.$set(this.dialogCommissionValue, field, this.tableData[index][field] || [])
        })
      }
    },
    saveDialog(type) {
      if (type === 'profit') {
        this.dialogProfitShow = false
        this.dialogTableKeys.forEach(key => {
          this.tableData[this.dialogIndex][key] = window._.cloneDeep(this.dialogProfitValue[key])
          this.syncChange(this.dialogIndex, key)
        })
      } else if (type === 'commission') {
        this.dialogCommissionShow = false
        this.dialogTableKeys.forEach(key => {
          this.tableData[this.dialogIndex][key] = window._.cloneDeep(this.dialogCommissionValue[key])
          this.syncChange(this.dialogIndex, key)
        })
      } else if (type === 'comment') {
        this.dialogComment = false
        this.tableData[this.dialogIndex].备注 = this.commentValue
        this.syncChange(this.dialogIndex, '备注')
      }
    },
    addrow(type, key) {
      const obj = {
        account: '',
        profitPercent: 0,
        performance: 0,
        commissionPercent: 25,
        commission: 0,
        type: '比例',
      }
      if (type === 'profit') {
        this.dialogProfitValue[key].push(obj)
      } else if (type === 'commission') {
        this.dialogCommissionValue[key].push(obj)
      }
    },
    removerow(type, key, index) {
      if (type === 'profit') {
        this.dialogProfitValue[key].splice(index, 1)
      } else if (type === 'commission') {
        this.dialogCommissionValue[key].splice(index, 1)
      }
    },
    async setOption() {
      if (!app.categories) {
        await app.getCats()
      }
      const notshow = ['admin', 'test', 'wpgao', 'cctang', 'test1', 'yezuochang', 'hktang']
      this.selectOption.职能模块 = app.categories.map(category => ({ label: category.名称, value: category.名称 }))
      if (!app.accounts) {
        await app.getUsers()
      }
      const showAccount = app.accounts.filter(val => !notshow.includes(val))
      this.users = showAccount
      this.serchOption.offer = showAccount
      this.serchOption.顾问 = showAccount
      this.serchOption.职能模块 = app.categories.map(category => category.名称)
      this.selectOption.offer = showAccount.map(account => ({ label: account, value: account }))
    },
    upload() {
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
    },
    async uploadsuccess(responce, file, filelist) {
      this.parseing = true
      const result = await window.app.service('company').uploadXlsx(responce[0]._id)
      this.parseing = false
      if (result.status === 'success') {
        this.loadData()
      } else {
        this.$message(result.msg)
      }
    },
    async uploaderror(responce) {
      console.log(responce)
    },
    handleCurrentChange(val) {
      this.page = val
      this.loadData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    sortChange(data) {
      if (this.activeFinanceType === '新') return
      const fields = ['年份', '序号', '开票批次']
      const key = data.prop
      const value = data.order === 'descending' ? -1 : 1
      if (fields.includes(key)) {
        this.sort[key] = value
      } else {
        const oldsort = this.sort
        const newsort = { [key]: value }
        fields.forEach(field => {
          newsort[field] = oldsort[field]
        })
        this.sort = newsort
      }
      this.loadData()
    },
    async save() {
      const list = []
      const { copyTable } = this
      this.tableData.forEach((v, i) => {
        const copyRow = copyTable[i]
        if (JSON.stringify(v) !== JSON.stringify(copyRow)) list.push(v)
      })

      if (list.length === 0) return this.$message.error('未对数据进行修改')
      const result = await window.app.service('company').saveFinance(list)
      if (result.status === 200) {
        this.$message('保存成功')
        // this.changeIndex = []
        this.loadData()
      } else {
        this.$message('保存失败，请稍后重试')
      }
    },
    async loadData() {
      const option = {
        page: this.page,
        pageSize: this.pageSize,
        sort: this.sort,
        query: this.serchKey,
        financeType: this.financeType,
        expired: this.expired,
      }
      this.activeFinanceType = this.financeType
      try {
        const { data, page, pageSize, total } = await window.app.service('company').getFinance(option)
        this.tableData = data
        this.copyTable = window._.cloneDeep(data)
        this.page !== page && (this.page = page)
        this.pageSize !== pageSize && (this.pageSize = pageSize)
        this.total !== total && (this.total = total)
        this.getActiveTableHead()
      } catch (error) {
        this.$message(error.message)
      }
    },
    floatMul(arg = []) {
      let m = 0
      const arr = []
      arg.forEach(val => {
        try {
          const s = val.toString()
          arr.push(s)
          m += s.split('.')[1].length
        } catch (e) {}
      })
      let sum
      arr.forEach((val, index) => {
        if (index === 0) sum = Number(val.replace('.', ''))
        else sum *= Number(val.replace('.', ''))
      })
      return sum / Math.pow(10, m)
      // return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m)

      // let m = 0
      // const s1 = arg1.toString()
      // const s2 = arg2.toString()
      // try {
      //   m += s1.split('.')[1].length
      // } catch (e) {}
      // try {
      //   m += s2.split('.')[1].length
      // } catch (e) {}
      // return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m)
    },
    async previewPay(file) {
      const ref = app.root.$refs.cvPreview
      if (!ref) return
      await ref.getFile(file)
      ref.show()
    },
    hasPayDoc(row) {
      return row.paydocs && row.paydocs.length > 0
      // row.radishProject &&
      // row.radishProject.状态 &&
      // (row.radishProject.状态.detail === '已开票' ||
      //   (row.radishProject.状态.tag == '过保' && row.radishProject.状态.detail === '未开票')) &&
    },
  },
}
</script>
<style>
.hidden-select .el-input__suffix {
  display: none;
}
.hidden-select input.el-input__inner {
  padding-right: 0;
}
.finance .el-table .finance-info-row,
.finance .el-table .finance-info-row.hover-row {
  background: #e7e8e9;
}
.finance .el-table .finance-info-row.hover-row > td,
.finance .el-table .finance-info-row.current-row > td {
  background-color: #e7e8e9;
}
.radish-btn.radish-btn-success {
  background-color: #67c23a;
  color: #fff;
}
.radish-btn.radish-btn-info {
  background-color: #bfbfbf;
  color: #fff;
}
</style>
<style src="../statistics/css/finance.css" scoped></style>
